import React from 'react';

/**
 * A reusable component for individual setting items
 * 
 * @param {Object} props - Component props
 * @param {string} props.title - The title of the setting
 * @param {string} props.description - The description of the setting
 * @param {React.ReactNode} props.control - The control element (toggle, select, etc.)
 */
const SettingItem = ({ title, description, control }) => {
  return (
    <div className="flex items-center justify-between py-3">
      <div>
        <h4 className="font-medium text-text-primary">{title}</h4>
        <p className="text-sm text-text-secondary">{description}</p>
      </div>
      {control}
    </div>
  );
};

export default SettingItem;